import { SetFilters, SetFiltersObject, SetInitialFilters } from '~/constants/actions';
import { SetQueryValue } from '~/constants/mutations';
import { GetFilters, GetSearchQuery } from '~/constants/getters';

const defaultState = () => {
  return {
    formFilters: {},
    queryValue: '',
  };
};

const state = defaultState();

const mutations = {
  [SetQueryValue](state, value) {
    state.queryValue = value;
  },

  [SetFilters](state, { type, key, value }) {
    const currentTypeFilters = state.formFilters[type] || {};

    // Ensure value is an array
    const newValue = Array.isArray(value) ? value : [value];

    // Remove key if empty array or null
    if (!value || (Array.isArray(value) && value.length === 0)) {
      const { [key]: removed, ...rest } = currentTypeFilters;

      if (Object.keys(rest).length === 0) {
        // Remove entire type if no filters remain
        const { [type]: removedType, ...remaining } = state.formFilters;
        state.formFilters = remaining;
      } else {
        state.formFilters = { ...state.formFilters, [type]: rest };
      }
      return;
    }

    // Update the filter if it has changed
    const currentValue = currentTypeFilters[key] || [];
    const isEqual = currentValue.length === newValue.length && currentValue.every((v, i) => v === newValue[i]);

    if (!isEqual) {
      state.formFilters = {
        ...state.formFilters,
        [type]: {
          ...currentTypeFilters,
          [key]: newValue,
        },
      };
    }
  },
  [SetFiltersObject](state, filters) {
    state.formFilters = { ...state.formFilters, ...filters };
  },
  [SetInitialFilters](state, type) {
    if (type) {
      state.formFilters[type] = {};
      return;
    }
    state.formFilters = {};
  },
};

const getters = {
  [GetFilters](state) {
    return state.formFilters;
  },
  [GetSearchQuery](state) {
    return state.queryValue;
  },
};

const actions = {
  [SetQueryValue]: ({ commit }, value) => {
    commit(SetQueryValue, value);
  },
  [SetFilters]: ({ commit }, data) => {
    commit(SetFilters, data);
  },
  [SetInitialFilters]: ({ commit }) => {
    commit(SetInitialFilters);
  },
  [SetFiltersObject]: ({ commit }, filters) => {
    commit(SetFiltersObject, filters);
  },
  [SetInitialFilters]: ({ commit }, data) => {
    commit(SetInitialFilters, data);
  },
};

export default {
  namespaced: true, // Important for namespacing module
  state,
  mutations,
  actions,
  getters,
};
